import { Resolution } from '@/modules/shared/types';
import type { WidgetConfig } from '@/modules/ctx-dashboard';
import { WidgetType } from '@/modules/ctx-dashboard';
import type { WidgetPreset } from '@/components/widget-wizard';

export default class CustomTimeChart implements WidgetPreset {

    public readonly name: string = 'custom-stacked-timechart';
    public readonly type: WidgetType = WidgetType.StackedTimeChart;
    public readonly quickAdd: boolean = false;
    public readonly order: number = 0;
    public readonly metrics: string[] = [];

    public async createWidget(params: { portfolio: string; dashboard: string }): Promise<WidgetConfig> {
        return {
            key: '',
            portfolioKey: params.portfolio,
            dashboardKey: params.dashboard,
            order: 0,
            config: {
                apexConfig: {
                    chart: {
                        stacked: true,
                        stackType: 'normal',
                    },
                },
            },
            type: this.type,
            preset: this.name,
            title: '',
            generatedTitle: '',
            intervalName: 'this-month-complete',
            intervalTo: new Date(),
            intervalFrom: new Date(),
            resolution: Resolution.Automatic,
            axis: [{
                unit: '',
                name: '',
                metrics: [],
                config: {},
            }, {
                unit: '',
                name: '',
                metrics: [],
                config: {},
            }],
        };
    }
}
